{
  "name": "github-router",
  "version": "0.3.153",
  "license": "MIT",
  "description": "A reverse proxy that exposes GitHub Copilot as OpenAI and Anthropic compatible API endpoints.",
  "keywords": [
    "proxy",
    "github-copilot",
    "openai-compatible",
    "anthropic-compatible",
    "claude-code",
    "codex",
    "reverse-proxy",
    "copilot"
  ],
  "homepage": "https://github.com/animeshkundu/github-router",
  "bugs": "https://github.com/animeshkundu/github-router/issues",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/animeshkundu/github-router.git"
  },
  "author": "animeshkundu",
  "type": "module",
  "bin": {
    "github-router": "dist/main.js"
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsdown && bun scripts/copy-browser-ext.ts",
    "dev": "bun run --watch ./src/main.ts",
    "discover:fields": "bash scripts/discover-new-fields.sh",
    "knip": "knip-bun",
    "lint": "eslint --cache",
    "lint:all": "eslint --cache .",
    "prepack": "bun run build",
    "prepare": "(simple-git-hooks || true)",
    "probe:copilot": "bash scripts/probe-copilot-compat.sh --strict",
    "release": "./publish/release.sh",
    "start": "NODE_ENV=production bun run ./src/main.ts",
    "test": "bun test",
    "typecheck": "tsc"
  },
  "simple-git-hooks": {
    "pre-commit": "bunx lint-staged"
  },
  "trustedDependencies": [
    "@vscode/ripgrep"
  ],
  "lint-staged": {
    "*": "bun run lint --fix"
  },
  "dependencies": {
    "@vscode/ripgrep": "^1.18.0",
    "citty": "^0.1.6",
    "clipboardy": "^5.3.1",
    "consola": "^3.4.2",
    "fetch-event-stream": "^0.1.6",
    "gpt-tokenizer": "^3.4.0",
    "hono": "^4.12.23",
    "ignore": "7.0.5",
    "marked": "^18.0.5",
    "partial-json": "0.1.7",
    "proxy-from-env": "^1.1.0",
    "srvx": "^0.8.16",
    "tree-sitter-wasms": "^0.1.13",
    "typebox": "1.1.38",
    "undici": "^7.27.0",
    "web-tree-sitter": "0.22.6",
    "ws": "^8.21.0",
    "yaml": "2.9.0",
    "zod": "^4.4.3"
  },
  "devDependencies": {
    "@eslint/js": "^9.39.4",
    "@types/bun": "^1.3.14",
    "@types/proxy-from-env": "^1.0.4",
    "@types/ws": "^8.18.1",
    "eslint": "^9.39.4",
    "eslint-config-prettier": "^10.1.8",
    "knip": "^5.88.1",
    "lint-staged": "^16.4.0",
    "playwright": "^1.60.0",
    "prettier-plugin-packagejson": "^2.5.22",
    "simple-git-hooks": "^2.13.1",
    "tsdown": "^0.15.12",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.60.1"
  }
}
